// src/hooks/useScrollReset.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollReset = (ref) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (ref?.current) {
      ref.current.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname]);
};